import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ProjectItem, Item, WsProjectInfo, ResponseProject, ExecutionResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class ProjectService {

  constructor(
    private http: HttpClient) { }

  getProjectItems(idParent: string, type: string, columnName?: string, orderBy?: string): Promise<ProjectItem> {
    return this.http.get<ProjectItem>(`${environment.apiUrl}/Project-GetProjectItems`,
      {
        params: new HttpParams()
          .set('id-parent', idParent)
          .set('type', type)
          .set('key', columnName)
          .set('orderby', orderBy),
      }
    ).toPromise();
  }

  getRecentItems(idParent: string): Promise<{ items: Item[] }> {
    return this.http.get<{ items: Item[] }>(`${environment.apiUrl}/Project-RecentItems`,
      {
        params: new HttpParams().set('id-project', idParent)
      }
    ).toPromise();
  }

  async getSingleProject(idProject: string): Promise<WsProjectInfo> {
    return this.http.get<WsProjectInfo>(`${environment.apiUrl}/SingleProject-ProjectInformation`,
      {
        params: new HttpParams().set('id-project', idProject)
      }
    ).toPromise();
  }

  addNewFolder(parentId: string, isParentAproject: boolean, folderName: string, tool: string): Promise<ResponseProject> {
    return this.http.post<ResponseProject>(`${environment.apiUrl}/Project-AddNewFolder`,
      {
        parent_id: parentId,
        is_parent_a_project: isParentAproject,
        folder_name: folderName,
        tool
      }
    ).toPromise();
  }

  addNewExecution(
    parentId: string,
    isParentAproject: boolean,
    executionName: string,
    idTool: string,
    toolName : string,
    isPrivateExecution: boolean,
    companyName: string,
  ): Promise<ExecutionResponse> {
    return this.http.post<ExecutionResponse>(`${environment.apiUrl}/Project-AddNewExecution`,
      {
        parent_id: parentId,
        is_parent_a_project: isParentAproject,
        execution_name: executionName,
        id_tool: idTool,
        is_private_execution: isPrivateExecution,
        company_name: companyName,
        tool_name : toolName,
      }
    ).toPromise();
  }

  
}
